export const TERMINATE_INACTIVE_TAG_EXACT = '/tag/terminate';
export const TERMINATE_INACTIVE_TAG = suffix => `/tag/terminate/${suffix}`;